exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.meeting_chat .el-image__inner,\r\n.el-image__placeholder,\r\n.el-image__error {\r\n  width: auto !important;\n}\r\n", ""]);

// exports
